// extracted by mini-css-extract-plugin
module.exports = {"container":"slidermenuitem_container__2NdSb","circle":"slidermenuitem_circle__2Ltrl","text":"slidermenuitem_text__3lNWz","img":"slidermenuitem_img__69cFy"};